import { render, staticRenderFns } from "./pg-table-input.vue?vue&type=template&id=67e0b9b2&scoped=true"
import script from "./pg-table-input.vue?vue&type=script&lang=js"
export * from "./pg-table-input.vue?vue&type=script&lang=js"
import style0 from "./pg-table-input.vue?vue&type=style&index=0&id=67e0b9b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0b9b2",
  null
  
)

export default component.exports